var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#medium_svg_01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 13.9241C25 7.41227 21.9176 2.11969 21.9176 2.11969C18.8352 -0.0555335 15.901 -0.000113861 15.901 -0.000113861L15.6046 0.31855C19.2501 1.37152 20.9395 2.88171 20.9395 2.88171C15.8566 0.249275 9.88441 0.249275 4.94962 2.2998C4.1642 2.64618 3.68998 2.88171 3.68998 2.88171C3.68998 2.88171 5.46829 1.28839 9.32128 0.23542L9.09899 -0.000113861C9.09899 -0.000113861 6.16479 -0.0555335 3.08239 2.11969C3.08239 2.11969 0 7.39842 0 13.9241C0 13.9241 1.79312 16.8613 6.53527 16.9999C6.53527 16.9999 7.32069 16.0855 7.97273 15.3234C5.246 14.5476 4.22347 12.9265 4.22347 12.9265C4.53468 13.1344 5.05335 13.4115 5.09781 13.4392C8.71369 15.3511 13.8411 15.9746 18.4499 14.1458C19.2057 13.8825 20.0356 13.4946 20.9099 12.9542C20.9099 12.9542 19.8429 14.6168 17.0421 15.365C17.6793 16.1409 18.4499 16.9999 18.4499 16.9999C23.1772 16.8613 25 13.9241 25 13.9241Z",
    fill: "#0A0909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4945 9.7954C18.4945 11.0285 17.5313 12.0399 16.3161 12.0399C15.1158 12.0399 14.1377 11.0285 14.1377 9.7954C14.1377 8.56231 15.1009 7.5509 16.3161 7.5509C17.5313 7.5509 18.4945 8.56231 18.4945 9.7954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49093 7.5509C7.27575 7.5509 6.3125 8.56231 6.3125 9.7954C6.3125 11.0285 7.29057 12.0399 8.49093 12.0399C9.7061 12.0399 10.6694 11.0285 10.6694 9.7954C10.699 8.56231 9.72092 7.5509 8.49093 7.5509Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medium_svg_01"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.ab1a25f6.svg";
export { ForwardRef as ReactComponent };